import { useSelector } from 'react-redux'
import { UserDashboardPage } from './UserDashboardPage'
import { VendorStaffDashboard } from './VendorStaffDashboard'
import CommonHome from '../../components/UserDashboard/Vendor/CommonHome'
export const DashboardPage = () => {
	const accountType = useSelector((state) => state.auth.accountType)

	const renderDashboard = () => {
		switch (accountType) {
			case 'user':
				return <UserDashboardPage />
			case 'vendor':
				return <CommonHome />
			case 'kazoo-planner':
				return <CommonHome />
			case 'vendor-staff':
			case 'planner-staff':
				return <VendorStaffDashboard />
		}
	}

	return (
		<div key={accountType}>
			{/* Main Area */}
			<div>{renderDashboard()}</div>
		</div>
	)
}
